import type { ReactNode } from 'react'
import { createPortal } from 'react-dom'

/** One existing surface and its handlers; only the presentation host changes. */
export function renderWorkspaceSurface(children: ReactNode, inline: boolean): ReactNode {
  return inline ? children : createPortal(children, document.body)
}
